import React from 'react';
import Slider from 'slider';
import YouTube from 'react-youtube';
import {Videos} from 'api';

class HighlightVideo extends React.Component {
  constructor(props, context) {
    super(props, context);

    this.state = {
      data: [],
      limit: 3
    };
  }

  componentDidMount() {
    let params = {
      filter: {
        order: 'createdAt DESC'
      }
    };
    Videos.actions.all.request(params).then(response => {
      this.setState({
        data: response.data
      });
    });
  }

  _onReady(event) {
    // access to player in all event handlers via event.target
    event.target.pauseVideo();
  }

  render() {
    const opts = {
        height: '247',
        width: '448'
    };
    const settings = {
      className: 'slider variable-width custom-react-slick',
      dots: false,
      infinite: false,
      centerMode: false,
      slidesToShow: 3,
      slidesToScroll: 1,
      variableWidth: true,
      responsive: [{
        breakpoint: 1201,
        settings: {
          slidesToShow: 2
        }
      },{
        breakpoint: 770,
        settings: {
          slidesToShow: 1
        }
      }]
    };

    return (
      <section className='center highlight-promotion-container'>
        <div className='banner-demand-row'>
          <Slider {...settings}>
            {
              this.state.data.map((item, index) => {
                return(
                  <div className='wrap-abnner-demand hinghlight-item demand-video'>
                  <YouTube
                      videoId={item.linkId}
                      opts={opts}
                      onReady={this._onReady}
                  />
                  </div>
                )
              })
            }
          </Slider>
        </div>
      </section>
    );
  }
  
}

export default HighlightVideo;



// WEBPACK FOOTER //
// ./components/home/sub-view/HighlightVideo.jsx